import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    Cell,
} from 'recharts';
import LanguageIcon from '@mui/icons-material/Language';
import { getLanguageDetails } from './languageHelpers';

const PALETTE = ['#1565c0', '#1b5e20', '#6a1b9a', '#c2410c', '#0e7490', '#b45309'];

export default function TopLanguagesChart({ languages }) {
    const data = (languages || [])
        .slice(0, 6)
        .map((l) => ({
            name: getLanguageDetails(l.name).name || l.name,
            count: l.count,
        }));

    return (
        <Paper
            sx={{
                p: 3,
                borderRadius: '16px',
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.06)',
                height: '100%',
                minHeight: 320,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Typography variant="h6" sx={{ mb: 2 }}>
                Top languages used
            </Typography>
            {data.length > 0 ? (
                <Box sx={{ flex: 1, width: '100%', minHeight: 240 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                            layout="vertical"
                            data={data}
                            margin={{ top: 10, right: 24, bottom: 0, left: 24 }}
                        >
                            <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#eee" />
                            <XAxis type="number" tick={{ fontSize: 12 }} allowDecimals={false} />
                            <YAxis
                                type="category"
                                dataKey="name"
                                tick={{ fontSize: 13 }}
                                width={100}
                            />
                            <Tooltip
                                formatter={(value) => [`${value.toLocaleString()} uses`, 'Used']}
                            />
                            <Bar dataKey="count" radius={[0, 6, 6, 0]}>
                                {data.map((_, idx) => (
                                    <Cell key={idx} fill={PALETTE[idx % PALETTE.length]} />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </Box>
            ) : (
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'text.secondary',
                        gap: 1,
                    }}
                >
                    <LanguageIcon sx={{ fontSize: 48, opacity: 0.4 }} />
                    <Typography variant="body2">
                        No language data yet — translate a project to populate this.
                    </Typography>
                </Box>
            )}
        </Paper>
    );
}
